import type { VehicleType } from "@slfinrtl/ui-bff-routes"

export const isInUseDisabled = (vehicleType: VehicleType) =>
	["NEW_CAR", "USED_CAR", "COMMISSION_CAR"].includes(vehicleType)
